module.exports = __webpack_public_path__ + "img/pickup-car.0dd7f1ff.svg";